import { render, staticRenderFns } from "./CustomfieldsForm.vue?vue&type=template&id=5bade110&scoped=true&"
import script from "./CustomfieldsForm.vue?vue&type=script&lang=js&"
export * from "./CustomfieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bade110",
  null
  
)

export default component.exports